// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionA_TheComp__Lgn61"};